import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import SubmitRes from '../../components/result/SubmitRes';
import '../../assets/scss/Wallet/withdrawRes.scss';

class WithdrawRes extends Component {
  constructor() {
    super();
    this.state = {
      withdrawData: {}
    }
  }
  componentDidMount() {
    const withdrawRes = window.sessionStorage.getItem('withdrawRes');
    if (withdrawRes) {
      this.setState({
        withdrawData: JSON.parse(withdrawRes)
      })
    } else {
      window.sessionStorage.removeItem('withdrawRes');
      this.props.history.goBack();
    }
  }

  render () {
    const { withdrawData } = this.state;
    return (
      <div>
        <Helmet><title>提现</title></Helmet>
        <div className='withdrawRes'>
          <div className='result'>
            <SubmitRes
              icon='success'
              mainText='提现申请已提交'
              subText='预计24小时内到账，节假日顺延，请留意短信通知'>
            </SubmitRes>
          </div>
          <ul>
            <li>
              <div>提现金额</div>
              <div>{withdrawData.withdrawAmount}</div>
            </li>
            <li>
              <div>到账金额</div>
              <div>{withdrawData.realAmount}</div>
            </li>
            <li>
              <div>扣税金额</div>
              <div>{withdrawData.taxAmount}</div>
            </li>
            <li>
              <div>到账银行</div>
              <div>{withdrawData.bankInfo}</div>
            </li>
            <li>
              <div>交易编号</div>
              <div><p className="p_bank">{withdrawData.orderNo}</p></div>
            </li>
            <li>
              <div>递交时间</div>
              <div>{withdrawData.orderTime}</div>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}

export default WithdrawRes;
